import bigDecimal from 'js-big-decimal';

export function gtmEcommerceEvents() {

	const withVatBool = window.globals.DW_SHOW_PRICES_WITH_VAT ? 'priceWithVat' : 'priceWithoutVat';

	const productImpressions = products => {
		dataLayer.push({
			'event': 'view_item_list',
			'ecommerce': {
				'item_list_id': 'product_overview',
				'item_list_name': 'Product overview',
				'items': products.map((product, index) => {
					return {
						'item_id': product.id,
						'item_name': product.name.replace('\'', ''),
						'item_number': product.number,
						'discount': product.discountAmount ? product.discountAmount.price : 0,
						'index': index + 1,
						'item_brand': product.manufacturer ? product.manufacturer.replace('\'', '') : '',
						'item_category': product.groupname.replace('\'', ''),
						'item_list_id': 'product_overview',
						'item_list_name': 'Product overview',
						'item_variant': product.variantid || '',
						'price': product.price[withVatBool],
						'quantity': 1,
					};
				})
			}
		});
	};

	const productClick = (product, index, isCtrlPress) => {

		dataLayer.push({
			'event': 'select_item',
			'ecommerce': {
				'items': [{
					'item_id': product.id,
					'item_name': product.name.replace('\'', ''),
					'item_number': product.number,
					'discount': product.discountAmount ? product.discountAmount.price : 0,
					'index': index + 1,
					'item_brand': product.manufacturer ? product.manufacturer.replace('\'', '') : '',
					'item_category': product.groupname.replace('\'', ''),
					'item_list_id': 'product_overview',
					'item_list_name': 'Product overview',
					'item_variant': product.variantid || '',
					'price': product.price[withVatBool],
					'quantity': 1,
				}]
			},
			'eventCallback': function () {
				if (isCtrlPress) {
					window.open(product.friendlyUrl);
					window.focus();
				} else {
					document.location = product.friendlyUrl;
				}
			},
			'eventTimeout': 2000
		});
	};

	const addToCart = (cart, product, qty, listId, listName) => {

		const value = JSON.parse(JSON.stringify(product.discountlines)).reduce((acc, discountLine) => {
			const totalPrice = new bigDecimal(discountLine.totalPrice[withVatBool]);
			return acc.add(totalPrice);
		}, new bigDecimal(product.totalPrice[withVatBool]));

		dataLayer.push({
			'event': 'add_to_cart',
			'ecommerce': {
				'currency': cart.price.currencyCode,
				'value': Number(value.getValue()),
				'items': [{
					'item_id': product.productId,
					'item_name': product.productName.replace('\'', ''),
					'item_number': product.productNumber,
					'discount': product.discountAmount ? product.discountAmount.price : 0,
					'index': 1,
					'item_brand': product.manufacturer ? product.manufacturer.replace('\'', '') : '',
					'item_category': product.groupname.replace('\'', ''),
					'item_list_id': listId,
					'item_list_name': listName,
					'item_variant': product.variantid || '',
					'price': product.unitPrice[withVatBool],
					'quantity': qty
				}]
			}
		});
	};

	const addToWishlist = (product, listId, listName, isCustom = false) => {
		let value = 0;
		let discount = 0;
		let price = 0;
		let currencyCode = '';

		if (isCustom) {
			value = Number(product.value);
			discount = Number(product.discount);
			price = Number(product.price);
			currencyCode = product.currencycode;
		} else {
			value = product.discountPrice ? product.discountPrice[withVatBool] : product.price[withVatBool];
			discount = product.discountAmount ? product.discountAmount.price : 0;
			price = product.price[withVatBool];
			currencyCode = product.price.currencyCode;
		}

		dataLayer.push({
			'event': 'add_to_wishlist',
			'ecommerce': {
				'currency': currencyCode,
				'value': value,
				'items': [{
					'item_id': product.id,
					'item_name': product.name.replace('\'', ''),
					'item_number': product.number,
					'discount': discount,
					'index': 1,
					'item_brand': product.manufacturer ? product.manufacturer.replace('\'', '') : '',
					'item_category': product.groupname.replace('\'', ''),
					'item_list_id': listId,
					'item_list_name': listName,
					'item_variant': product.variantid || '',
					'price': price,
					'quantity': 1
				}]
			}
		});
	};

	const removeFromCart = product => {

		const value = JSON.parse(JSON.stringify(product.discountlines)).reduce((acc, discountLine) => {
			const unitPrice = new bigDecimal(discountLine.totalPrice[withVatBool]);
			return acc.add(unitPrice);
		}, new bigDecimal(product.totalPrice[withVatBool]));

		dataLayer.push({
			'event': 'remove_fom_cart',
			'ecommerce': {
				'currency': product.unitPrice.currencyCode,
				'value': Number(value.getValue()),
				'items': [{
					'item_id': product.productId,
					'item_name': product.productName.replace('\'', ''),
					'item_number': product.productNumber,
					'discount': product.discountAmount ? product.discountAmount.price : 0,
					'index': 1,
					'item_brand': product.manufacturer ? product.manufacturer.replace('\'', '') : '',
					'item_category': product.groupname.replace('\'', ''),
					'item_list_id': 'shoppingcart',
					'item_list_name': 'Shoppingcart',
					'item_variant': product.variantid || '',
					'price': product.unitPrice[withVatBool],
					'quantity': product.quantity
				}]
			}
		});
	};

	const checkoutOption = (cart, eventType, value) => {
		const dataObj = {
			'ecommerce': {
				'currency': cart.price.currencyCode,
				'value': cart.price[withVatBool],
				'coupon': cart.vouchercode || '',
				'items': cart.orderLines.map((product, index) => {
					return {
						'item_id': product.productId,
						'item_name': product.productName.replace('\'', ''),
						'item_number': product.productNumber,
						'discount': product.discountAmount ? product.discountAmount.price : 0,
						'index': index + 1,
						'item_brand': product.manufacturer ? product.manufacturer.replace('\'', '') : '',
						'item_category': product.groupname.replace('\'', ''),
						'item_list_id': 'shoppingcart',
						'item_list_name': 'Shoppingcart',
						'item_variant': product.variantid || '',
						'price': product.unitPrice[withVatBool],
						'quantity': product.quantity,
					};
				})
			}
		};

		if (eventType === 'payment') {
			dataObj['event'] = 'add_payment_info';
			dataObj.ecommerce['payment_type'] = value;
		} else {
			dataObj['event'] = 'add_shipping_info';
			dataObj.ecommerce['shipping_tier'] = value;
		}

		dataLayer.push(dataObj);
	};

	return {
		productImpressions,
		productClick,
		addToCart,
		addToWishlist,
		removeFromCart,
		checkoutOption,
	};
}
